import { render, staticRenderFns } from "./ChooseTeam.vue?vue&type=template&id=03744d0e&scoped=true&"
import script from "./ChooseTeam.vue?vue&type=script&lang=js&"
export * from "./ChooseTeam.vue?vue&type=script&lang=js&"
import style0 from "./ChooseTeam.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChooseTeam.vue?vue&type=style&index=1&id=03744d0e&lang=scss&scoped=true&"
import style2 from "./ChooseTeam.vue?vue&type=style&index=2&id=03744d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03744d0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCardText,VCardTitle,VCol,VRow})
